'use client';

import { Toaster } from 'react-hot-toast';

export default function ToasterProvider() {
  return <Toaster data-component-id="src/components/common/ToasterProvider.tsx:6:9" data-component-path="src/components/common/ToasterProvider.tsx" data-component-line="6" data-component-end-line="6" data-component-file="ToasterProvider.tsx" data-component-name="Toaster" data-component-content="%7B%22elementName%22%3A%22Toaster%22%7D" position="top-right" />;
}

